import { inject, Injectable } from '@angular/core';
import { Environment } from '@rma/generic/util/environment';
import { RmaLocalStorageService } from '@rma/generic/util/local-storage';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class TokenProviderService {
  private readonly localStorage = inject(RmaLocalStorageService);
  private readonly cookiesService = inject(CookieService);
  private readonly environment = inject(Environment);

  private userTokenKey: string;

  public initialise() {
    this.userTokenKey = `${this.environment.jwtEnvironment}-UserToken`;

    if (!this.hasUserToken()) {
      const cookieToken = this.cookiesService.get('jwt');
      if (cookieToken) {
        this.setUserToken(cookieToken);
      }
    }
  }

  public setUserToken(userToken: string): void {
    this.localStorage.setItem(this.userTokenKey, userToken);
  }

  public getUserToken(): string | null {
    return this.localStorage.getItem(this.userTokenKey);
  }

  public hasUserToken(): boolean {
    const token = this.getUserToken();
    return !!token && token !== 'null' && token !== 'undefined';
  }

  public clearUserToken(): void {
    this.localStorage.removeItem(this.userTokenKey);
  }
}
